module.exports = __webpack_public_path__ + "img/thumb-spicy-tomatenpastasaus.7ff892a8.jpeg";